/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ID, WithVersion } from '@gh/common-shared-data';
import { createEnum, EnumSet } from '@gh/core-data';

export const ImportPricesErrorCodes = createEnum('UPLOAD_ITEMS_ERROR_CODES', {
  CodeEmpty: '2',
  NotUnique: '1',
  CodeIncorrectFormat: '3',
  PriceEmpty: '4',
  PriceIncorrectFormat: '5',
  Unexpected: '6',
  UoMNotFound: '7',
  DescriptionTooLong: '8',
  UoMNotUnique: '9',
});

export type ImportPricesErrorCodes = EnumSet<typeof ImportPricesErrorCodes>;

export type ImportPriceFileItemDto = WithVersion<{
  uploadItemId: ID;
  batchRowNumber: number;
  code: string;
  name: string;
  currentName: string;
  nameChanged: boolean;
  cost: number;
  currentCost: number;
  status: string; // ENUM
  variance: number;
  variancePct: number;
  isUp: boolean;
  uomId: ID;
  currentUomId: ID;
  uomChanged: boolean;
  memo: string;
  currentMemo: string;
  memoChanged: boolean;
  errorCodes: any[];
}>;
